import React from 'react';
import { SRP_HITS_PER_PAGE } from '../../utils/srp/srp-hits-per-page';

const DEFAULT_COUNT = SRP_HITS_PER_PAGE;

export interface SrpResultsGridSkeletonProps {
  /** Number of placeholder cards (matches typical hitsPerPage). */
  count?: number;
}

/**
 * Placeholder grid while SRP results load (slim client payload or Algolia in flight).
 * Mirrors the `.hit-card-v2` DOM shape (panel + content columns) so swap to the real
 * HitCompactView is stable (lower CLS).
 */
export function SrpResultsGridSkeleton({ count = DEFAULT_COUNT }: SrpResultsGridSkeletonProps): React.ReactElement {
  return (
    <ul className="srp-results-grid" aria-busy="true">
      {Array.from({ length: count }, (_, i) => (
        <li key={i} className="srp-results-grid-item">
          <div
            className="hit-card-v2 pointer-events-none select-none shadow-none"
            aria-hidden
          >
            <div className="hit-card-v2__panel bg-[#F2EADF] dark:bg-[#2A1D0F]">
              <div className="hit-card-v2__logo-tile bg-[#EDE6DC] dark:bg-[#342415] animate-pulse" />
              <div className="mt-3 h-4 w-3/4 rounded-md bg-[#EDE6DC]/80 dark:bg-[#342415]/80 animate-pulse" />
            </div>
            <div className="hit-card-v2__content">
              <div className="hit-card-v2__top-row">
                <div className="h-3 w-24 rounded-md bg-[#EDE6DC] dark:bg-[#342415] animate-pulse" />
                <div className="h-9 w-9 rounded-full bg-[#EDE6DC] dark:bg-[#342415] animate-pulse" />
              </div>
              <div className="mt-2 h-4 w-[88%] max-w-xl rounded-md bg-[#EDE6DC] dark:bg-[#342415] animate-pulse" />
              <div className="h-3 w-[52%] rounded-md bg-[#EDE6DC]/85 dark:bg-[#342415]/85 animate-pulse" />
              <div className="mt-auto flex flex-wrap items-center gap-2 pt-1">
                <span className="h-8 w-[4.5rem] shrink-0 rounded-lg bg-[#E5DDD4] dark:bg-[#3A2E22] animate-pulse" />
                <span className="h-8 min-w-[6rem] flex-1 max-w-[160px] rounded-lg bg-[#DDE8DF]/90 dark:bg-[#1A2E22]/90 animate-pulse" />
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
